"use client";

import React from "react";

//Type
import { CardProductProps } from "@/types";

//Style
import * as S from "./styles";

//Icons
import { Pencil, Scissors, Trash, Image as ImageIcon } from "lucide-react";

//Components
import ButtonIcon from "../buttonIcon";

//Image
import ImageProduct from "@/assets/images/corte-de-cabelo-masculino.jpg";

import { formatCurrency } from "@/utils/formatCurrency";

import { buildAvatarSrc } from "@/utils/buildAvatarSrc";

const CardProduct: React.FC<CardProductProps> = ({
  className,
  titleCard,
  price,
  brand,
  category,
  stock = 0,
  handleUpdate,
  handleRemove,
  cantEdit,
  cantDelete,
  currency,
  avatar_url,
  avatar_path,
  legacy_image_path,
}) => {
  const isLowStock = stock < 10;
  const imageSrc = buildAvatarSrc({
    avatar_url,
    avatar_path,
    legacy: legacy_image_path,
  });

  return (
    <S.CardProduct className={className}>
      <S.BoxContent>
        <S.HeaderCard>
          <S.FirstBox>
            {imageSrc ? (
              <S.ImgWrapper>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={imageSrc} alt={titleCard} />
              </S.ImgWrapper>
            ) : (
              <S.BoxIcon>
                <Scissors />
              </S.BoxIcon>
            )}
            <S.TitleCard title={titleCard}>{titleCard}</S.TitleCard>
          </S.FirstBox>
          <S.LastBox>
            <S.BoxAlertProduct $isLowStock={isLowStock}>
              {isLowStock ? "Baixo" : "Normal"}
            </S.BoxAlertProduct>
          </S.LastBox>
        </S.HeaderCard>
        <S.BodyCard>
          <S.ListInfoProduct>
            <S.ItemList>
              <S.TitleInfo>Marca</S.TitleInfo>
              <S.Description>{brand}</S.Description>
            </S.ItemList>
            <S.ItemList>
              <S.TitleInfo>Categoria</S.TitleInfo>
              <S.Description>{category}</S.Description>
            </S.ItemList>
            <S.ItemList>
              <S.TitleInfo>Estoque</S.TitleInfo>
              <S.Description>{stock} unidades</S.Description>
            </S.ItemList>
          </S.ListInfoProduct>
        </S.BodyCard>
        <S.FooterCard>
          <S.Value>{formatCurrency(Number(price), currency)}</S.Value>
          <S.LastBox>
            {cantEdit && (
              <ButtonIcon
                icon={<Pencil />}
                hovercolor="green"
                onClick={handleUpdate}
              />
            )}
            {cantDelete && (
              <ButtonIcon
                icon={<Trash />}
                hovercolor="red"
                onClick={handleRemove}
              />
            )}
          </S.LastBox>
        </S.FooterCard>
      </S.BoxContent>
    </S.CardProduct>
  );
};

export default CardProduct;
